import React, { useState, useEffect, useRef } from 'react';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl.js';
import { useSnackbar } from 'notistack';
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const markerIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

function LocationMarker({ markerPosition, onLocationSelect }) {
  useMapEvents({
    click(e) {
      onLocationSelect(e.latlng.lat, e.latlng.lng);
    }
  });

  return markerPosition ? <Marker position={markerPosition} icon={markerIcon} /> : null;
}

function Cities() {
  const Token = JSON.parse(localStorage.getItem('tcn'));
  const { enqueueSnackbar } = useSnackbar();

  const [search, setsearch] = useState('');
  const [cityList, setcityList] = useState([]);
  const [filtercityList, setfiltercityList] = useState([]);
  const [stateList, setstateList] = useState([]);

  const CityInputRef = useRef(null);

  const [CityId, setCityId] = useState('');
  const [CityName, setCityName] = useState('');
  const [StateId, setStateId] = useState(0);
  const [Latitude, setLatitude] = useState('');
  const [Longitude, setLongitude] = useState('');
  const [CityRadius, setCityRadius] = useState('');
  const [IsActive] = useState(true);
  const [CreatedBy] = useState(1);
  const [ModifiedBy] = useState(1);

  const [edit, setEdit] = useState(false);
  const [returnId, setreturnId] = useState(0);

  const defaultCenter = [20.5937, 78.9629];
  const [markerPosition, setmarkerPosition] = useState(defaultCenter);

  const CityURL = APIUrl.Cities;
  const StateURL = APIUrl.State;

  function doEmptyStates() {
    setCityId('');
    setCityName('');
    setStateId(0);
    setLatitude('');
    setLongitude('');
    setCityRadius('');
    setmarkerPosition(defaultCenter);
    setEdit(false);
    setreturnId(0);
  }

  const parseJSON = async (response) => {
    try {
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    }
    catch (err) {
      console.warn('Failed to parse JSON response', err);
      return null;
    }
  };

  const getAllState = async () => {
    try {
      const response = await fetch(StateURL + 'GetAllState', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Token}`
        },
        body: JSON.stringify()
      });

      const result = await parseJSON(response);
      if (result && result.data !== null) {
        setstateList(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAllCity = async () => {
    try {
      const response = await fetch(CityURL + 'GetAllCity', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Token}`
        },
        body: JSON.stringify()
      });

      const result = await parseJSON(response);

      if (result && result.data !== null) {
        setcityList(result.data);
        setfiltercityList(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllState();
    getAllCity();
  }, []);

  const handleLocationSelect = (lat, lng) => {
    const fixedLat = Number(lat).toFixed(6);
    const fixedLng = Number(lng).toFixed(6);

    setLatitude(fixedLat);
    setLongitude(fixedLng);
    setmarkerPosition([lat, lng]);
  };

  const insertCity = async () => {
    try {
      if (CityName.trim().length >= 2 && Number(StateId) > 0 && Latitude !== '' && Longitude !== '' && CityRadius !== '') {
        const data = { CityName, StateId: Number(StateId), Latitude, Longitude, CityRadius, IsActive, CreatedBy, ModifiedBy };
        const response = await fetch(CityURL + 'InsertCity', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Token}`
          },
          body: JSON.stringify(data)
        });

        const result = await parseJSON(response);
        if (result && result.returnID !== undefined) {
          setreturnId(result.returnID);
          enqueueSnackbar('Successfully Added', { variant: 'success' });
          getAllCity();
          doEmptyStates();
        } else {
          enqueueSnackbar('Add failed: empty response', { variant: 'error' });
        }
      }
      else {
        enqueueSnackbar('Fill all required fields to submit', { variant: 'warning' });
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const editCity = async (Id) => {
    try {
      const items = cityList.filter((x) => x.CityId === Id);

      items.forEach((item) => {
        const lat = item.Latitude ?? '';
        const lng = item.Longitude ?? '';

        setCityId(item.CityId);
        setCityName(item.CityName || item.City || '');
        setStateId(item.StateId || 0);
        setLatitude(lat !== '' ? String(lat) : '');
        setLongitude(lng !== '' ? String(lng) : '');
        setCityRadius(item.CityRadius !== undefined && item.CityRadius !== null ? String(item.CityRadius) : '');

        if (lat !== '' && lng !== '') {
          setmarkerPosition([Number(lat), Number(lng)]);
        } else {
          setmarkerPosition(defaultCenter);
        }

        setreturnId(item.CityId);
      });

      setEdit(true);
      CityInputRef.current.focus();
    }
    catch (error) {
      console.log(error);
    }
  };

  const updateCity = async (Id) => {
    try {
      if (CityName.trim().length >= 2 && Number(StateId) > 0 && Latitude !== '' && Longitude !== '' && CityRadius !== '') {
        const data = {
          CityId,
          CityName,
          StateId: Number(StateId),
          Latitude,
          Longitude,
          CityRadius,
          ModifiedBy
        };

        const response = await fetch(CityURL + 'UpdateCity/' + Id, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Token}`
          },
          body: JSON.stringify(data)
        });

        const result = await parseJSON(response);
        if (result && result.returnID !== undefined) {
          setreturnId(result.returnID);
          getAllCity();
          doEmptyStates();
          enqueueSnackbar('Successfully Updated', { variant: 'success' });
        } else {
          enqueueSnackbar('Update failed: empty response', { variant: 'error' });
        }
      }
      else {
        enqueueSnackbar('Fill all required fields to update', { variant: 'warning' });
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const activateDeactivateCity = async (Id, Value) => {
    try {
      const data = { Value };
      const response = await fetch(CityURL + 'ActivateDeactivateCity/' + Id, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Token}`
        },
        body: JSON.stringify(data)
      });

      const result = await parseJSON(response);
      if (result && result.returnID !== undefined) {
        setreturnId(result.returnID);
        getAllCity();
        doEmptyStates();

        Value === 'activate'
          ? enqueueSnackbar('Successfully Activated', { variant: 'success' })
          : enqueueSnackbar('Successfully Deactivated', { variant: 'warning' });
      } else {
        enqueueSnackbar('Status change failed: empty response', { variant: 'error' });
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const result = cityList.filter((x) => {
      const stateName = x.StateName || x.State || '';
      const cityName = x.CityName || x.City || '';
      return `${cityName} ${stateName}`.toLowerCase().match(search.toLowerCase());
    });

    setfiltercityList(result);
  }, [search, cityList]);

  const coloumn = [
    {
      name: <strong>SNo.</strong>,
      selector: (row, index) => index + 1
    },
    {
      name: <strong>Reference Id</strong>,
      selector: (row) => row.CityId
    },
    {
      name: <strong>State</strong>,
      selector: (row) => row.StateName || row.State,
      sortable: true,
      reorder: true
    },
    {
      name: <strong>City</strong>,
      selector: (row) => row.CityName || row.City,
      sortable: true,
      reorder: true
    },
    {
      name: <strong>Latitude</strong>,
      selector: (row) => row.Latitude
    },
    {
      name: <strong>Longitude</strong>,
      selector: (row) => row.Longitude
    },
    {
      name: <strong>Radius</strong>,
      selector: (row) => row.CityRadius
    },
    {
      name: <strong>Activated/Deactivated</strong>,
      selector: (row) => row.IsActive
        ? <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label>
        : <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">Deactivated</label>
    },
    {
      name: <strong>Action</strong>,
      cell: (row) =>
        <div>
          {
            !row.IsActive
              ? <Button onClick={() => activateDeactivateCity(row.CityId, 'activate')} data-tip="Click to Activate City" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-toggle-off" aria-hidden="true"></i></Button>
              : <Button onClick={() => activateDeactivateCity(row.CityId, 'deactivate')} data-tip="Click to Deactivate City" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-toggle-on" aria-hidden="true"></i></Button>
          }
          <Button onClick={() => editCity(row.CityId)} data-tip="Click to Edit Details" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-pencil" aria-hidden="true"></i></Button>
        </div>
    }
  ];

  return (
    <div>
      <Layout>
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">
                Add New City
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
                <div>
                  <label htmlFor="stateId" className="block text-sm font-medium text-gray-700 mb-2">
                    State
                  </label>
                  <select
                    id="stateId"
                    name="stateId"
                    value={StateId}
                    onChange={(e) => setStateId(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                  >
                    <option value={0}>Select State</option>
                    {stateList.filter((x) => x.IsActive !== false).map((item) => (
                      <option key={item.StateId} value={item.StateId}>
                        {item.StateName || item.State}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="cityName" className="block text-sm font-medium text-gray-700 mb-2">
                    City Name
                  </label>
                  <input
                    type="text"
                    id="cityName"
                    name="cityName"
                    value={CityName}
                    ref={CityInputRef}
                    onChange={(e) => { setCityName(e.target.value); }}
                    placeholder="Enter City Name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                  />
                </div>

                <div>
                  <label htmlFor="latitude" className="block text-sm font-medium text-gray-700 mb-2">
                    Latitude
                  </label>
                  <input
                    type="number"
                    step="0.000001"
                    id="latitude"
                    name="latitude"
                    value={Latitude}
                    onChange={(e) => setLatitude(e.target.value)}
                    placeholder="Latitude"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                  />
                </div>

                <div>
                  <label htmlFor="longitude" className="block text-sm font-medium text-gray-700 mb-2">
                    Longitude
                  </label>
                  <input
                    type="number"
                    step="0.000001"
                    id="longitude"
                    name="longitude"
                    value={Longitude}
                    onChange={(e) => setLongitude(e.target.value)}
                    placeholder="Longitude"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                  />
                </div>

                <div>
                  <label htmlFor="cityRadius" className="block text-sm font-medium text-gray-700 mb-2">
                     Radius (in Kms)
                  </label>
                  <label className="block text-xs text-gray-500 mb-1">
                    (This radius will be used to show properties within this distance from the city center)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    id="cityRadius"
                    name="cityRadius"
                    value={CityRadius}
                    onChange={(e) => setCityRadius(e.target.value)}
                    placeholder="City Radius"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                  />
                </div>
              </div>

              <div className="mt-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select Location (click map to drop pin)
                </label>
                <div className="h-72 rounded-lg overflow-hidden border border-gray-300">
                  <MapContainer center={markerPosition || defaultCenter} zoom={5} className="h-full w-full" scrollWheelZoom={true}>
                    <TileLayer
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <LocationMarker markerPosition={markerPosition} onLocationSelect={handleLocationSelect} />
                  </MapContainer>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-4">
                {
                  edit === false
                    ? <Button className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2" onClick={() => insertCity()}><span>Add</span></Button>
                    : <Button className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2" onClick={() => updateCity(returnId)}><span>Update</span></Button>
                }

                <button
                  type="button"
                  onClick={() => doEmptyStates()}
                  className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                >
                  Reset
                </button>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="overflow-x-auto">
                <DataTable
                  title="Manage City"
                  columns={coloumn}
                  data={filtercityList}
                  pagination
                  fixedHeader
                  fixedHeaderScrollHeight="550px"
                  selectableRows
                  selectableRowsHighlight
                  highlightOnHover
                  subHeader
                  subHeaderAlign="right"
                  subHeaderComponent={
                    <input
                      type="text"
                      placeholder="search state/city"
                      className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      value={search}
                      onChange={(e) => setsearch(e.target.value)}
                    />
                  }
                />
              </div>
            </div>
          </div>
        </main>
      </Layout>
    </div>
  );
}

export default Cities;
